import { FC } from "react";
import Stack from "@mui/material/Stack";
import {
  FilterGroupNode,
  ResourceExplorerPossibleFilterV2,
} from "@/services/cloudchipr.api";
import { isTreeNodeFilterGroup } from "@/components/pages/common/filters-tree/utils/helpers/isTreeNodeWithIdFilterGroup";
import { findFilterProviderInTree } from "@/components/pages/common/filters-tree/utils/helpers/findFilterProviderInTree";
import { ProviderFilterTreeDisabledCard } from "@/components/pages/common/filters-tree/filters-disabled-view/components/ProviderFilterTreeDisabledCard";

interface FilterTreeDisabledViewProps {
  possibleFilters: ResourceExplorerPossibleFilterV2[];
  filterTree?: FilterGroupNode;
}

export const FilterTreeDisabledView: FC<FilterTreeDisabledViewProps> = ({
  possibleFilters,
  filterTree,
}) => {
  return (
    <Stack spacing={1.5}>
      {filterTree?.items.map((node) => {
        if (!isTreeNodeFilterGroup(node)) {
          // first level can't be filter items, should be groups
          return null;
        }

        const filterProvider = findFilterProviderInTree(node.items);

        if (!filterProvider) {
          return null;
        }

        return (
          <ProviderFilterTreeDisabledCard
            key={filterProvider}
            filters={node}
            filterProvider={filterProvider}
            possibleFilters={possibleFilters}
          />
        );
      })}
    </Stack>
  );
};
